export function getGrade(score) {
  if (score >= 90) return 'Tour Pro';
  if (score >= 80) return 'Elite';
  if (score >= 70) return 'Advanced';
  if (score >= 60) return 'Solid';
  if (score >= 50) return 'Intermediate';
  if (score >= 40) return 'Developing';
  return 'Beginner';
}
